export enum edenredProducts {
  ticketGuarderia = 7,
  ticketTransporte = 16,
  ticketRestaurant = 19,
  saludExterno = 23,
  iberiaCard = 24,
  premium = 33,
  formacion = 98,
  salud = 99,
  onlinePurchase = 999, // Uber Eats, etc
}
